import React from 'react';
import classnames from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import DesktopDevPageDisplayStage728x90 from '@wix/da-ads/pkg/adunits/DesktopDevPageDisplayStage728x90';
import { useDeviationViewContext } from '../../../Context';
import { useSelector } from 'react-redux';
import { getCurrentAdSafety } from '../../../Ads/redux/selectors';
import { useShouldRenderAdArea } from '@wix/da-ads/pkg/useShouldRenderAdArea';
import s from './StageContainer.scss';
export const StageContainer = ({ children , className  })=>{
    const adSafety = useSelector((state)=>getCurrentAdSafety(state));
    const { isTheater , isFullscreen  } = useDeviationViewContext();
    const showAd = useShouldRenderAdArea(adSafety);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isTheater && s['theater'], isFullscreen && s['fullscreen'], showAd && s['with-ad'], className),
        "data-hook": BiDataHook.DEVIATION_ART_STAGE
    }, showAd && /*#__PURE__*/ React.createElement("div", {
        className: s['ad-slot']
    }, /*#__PURE__*/ React.createElement(DesktopDevPageDisplayStage728x90, {
        safety: adSafety
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['stage-content']
    }, children));
};
StageContainer.displayName = 'StageContainer';
export default StageContainer;
